import {
  UPDATE_CATEGORY,
  RESET_CATEGORY
} from "./actionTypes"

export const update_category = category => {
  return {
    type: UPDATE_CATEGORY,
    payload: category,
  }
}

export const reset_category = () => {
  return {
    type: RESET_CATEGORY,
  }
}
